import styled, { css } from 'styled-components';
import { BasePaginatorHeader, BasePaginatorListItem } from 'styles/components';
import { PaginatorColumn } from 'styles/components';

export const List = styled.div`
  /* display: flex; */
  flex-direction: column;
  margin-top: 32px;
`;

const baseGridCss = css`
  grid-template-columns: 20px 50px 300px 80px 60px 60px 80px auto;
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${baseGridCss}/* display: flex; */
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${baseGridCss}/* display: flex; */
`;

export const Column = styled(PaginatorColumn)`
  flex: 1;

  &:nth-child(2) {
    flex: 3; /* faz a coluna do meio ocupar mais espaço */
  }
`;
